export const DAT_HANG_PERMISSION_CODES = {
  WEB_BH_DAT_HANG_LIST: 'WEB_BH_DAT_HANG_LIST',
  WEB_BH_DAT_HANG_CHI_TIET_LIST: 'WEB_BH_DAT_HANG_CHI_TIET_LIST',
  WEB_BH_DAT_HANG_DETAIL: 'WEB_BH_DAT_HANG_DETAIL',

  WEB_BH_DAT_HANG_ADD: 'WEB_BH_DAT_HANG_ADD',
  WEB_BH_DAT_HANG_EDIT: 'WEB_BH_DAT_HANG_EDIT',
  WEB_BH_DAT_HANG_DELETE: 'WEB_BH_DAT_HANG_DELETE',
  WEB_BH_DAT_HANG_STATUS: 'WEB_BH_DAT_HANG_STATUS',
  WEB_BH_DAT_HANG_EXPORT: 'WEB_BH_DAT_HANG_EXPORT',
  WEB_BH_DAT_HANG_IMPORT: 'WEB_BH_DAT_HANG_IMPORT',
  WEB_BH_DAT_HANG_COPY: 'WEB_BH_DAT_HANG_COPY',
  WEB_BH_DAT_HANG_FAVORITE: 'WEB_BH_DAT_HANG_FAVORITE',
  /** In nhiều đặt hàng đã chọn trên list — tách khỏi in từng dòng. */
  WEB_BH_DAT_HANG_PRINT_BATCH: 'WEB_BH_DAT_HANG_PRINT_BATCH',
  /** Hủy nhiều đặt hàng đã chọn trên list — tách khỏi hủy/đổi TT từng dòng. */
  WEB_BH_DAT_HANG_HUY_BATCH: 'WEB_BH_DAT_HANG_HUY_BATCH',
  /** Kết thúc nhiều đặt hàng đã chọn trên list — tách khỏi kết thúc từng dòng. */
  WEB_BH_DAT_HANG_KET_THUC_BATCH: 'WEB_BH_DAT_HANG_KET_THUC_BATCH',
} as const

export const DAT_HANG_MUTATE_PERMISSIONS = [
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_ADD,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_EDIT,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_DELETE,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_STATUS,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_IMPORT,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_EXPORT,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_COPY,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_FAVORITE,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_PRINT_BATCH,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_HUY_BATCH,
  DAT_HANG_PERMISSION_CODES.WEB_BH_DAT_HANG_KET_THUC_BATCH,
] as const
